// extracted by mini-css-extract-plugin
export default {"authorizationRequiredIcon":"AuthRequired_authorizationRequiredIcon__W4dxz"};